import MediaApi from "api/mediaApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { useModal } from "context/confirm.context";
import { catchAsync } from "helpers/general";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";

const AdsTxt = ({
  mediaDetail,
  values,
  setFieldValue,
  handleSubmit,
  mode,
  onClose,
}: any) => {
  const { t } = useTranslation();
  const { showModal } = useModal();
  const [clearing, setClearing] = useState(false);
  // 이 컴포넌트는 모달이 닫혀도 언마운트되지 않으므로, 방금 지웠다는 사실을
  // boolean 으로 들고 있으면 다음에 연 매체까지 따라간다. 매체 id 로 기억한다.
  const [clearedId, setClearedId] = useState<any>(null);

  // 통합 저장은 빈 문자열을 무시하므로 textarea 를 비우는 것만으로는 값이
  // 지워지지 않는다. 의도적으로 비울 때는 전용 엔드포인트를 쓴다.
  const hasSavedValue =
    !!mediaDetail?.ads_txt && clearedId !== mediaDetail?.id;

  const handleClear = async () => {
    const [err] = await catchAsync(
      MediaApi.deleteAdsTxt(mediaDetail?.id),
      setClearing
    );

    if (err) {
      toast(Object.values(err)?.[0] || err, CONFIG_OPTION_TOAST_ERROR);
      return;
    }

    // 폼에 남은 옛 값이 이후 통합 저장으로 다시 전송되면 삭제가 취소되므로
    // 반드시 비워둔다. getDetail 재조회는 쓰지 않는다 — mediaDetail 이 바뀌면
    // enableReinitialize 가 폼 전체를 재초기화해 다른 탭의 미저장 수정까지 날아간다.
    setFieldValue("ads_txt", "");
    setClearedId(mediaDetail?.id);
    toast("success", CONFIG_OPTION_TOAST_NORMAL);
  };

  const confirmClear = () => {
    showModal(
      {
        title: t("media.ads_txt_clear"),
        message: (
          <div>
            <div style={{ fontWeight: "600" }}>
              {t("media.ads_txt_clear_confirm_1")}
            </div>
            {t("media.ads_txt_clear_confirm_2")}
          </div>
        ),
        submitButtonText: t("media.ads_txt_clear"),
        // 파괴적 동작이라 기본 파란색(btn-primary) 대신 빨간색을 쓴다.
        submitButtonClass: "btn-danger",
        width: "497px",
      },
      async () => {
        return handleClear();
      }
    );
  };

  return (
    <form onSubmit={handleSubmit} className="w-100">
      <div className="fw-bold fs-14 text-gray-600 mt-4">
        {t("media.ads_txt")}
      </div>
      <div className="mt-3">
        <textarea
          className="form-control"
          id="adsTxt"
          rows={20}
          placeholder={t("media.placeholder_ads_txt")}
          value={values?.ads_txt || ""}
          readOnly={mode === "view"}
          onChange={(e: any) => setFieldValue("ads_txt", e.target.value)}
          style={{
            fontFamily: "monospace",
            whiteSpace: "pre",
            overflowWrap: "normal",
            overflowX: "auto",
          }}
        />
      </div>
      {mode !== "view" && hasSavedValue ? (
        <div className="d-flex align-items-center gap-2 mt-3">
          <button
            type="button"
            className="btn btn-soft-danger fs-14"
            disabled={clearing}
            onClick={confirmClear}
          >
            {clearing ? <Spinner size="sm" className="me-2" /> : null}
            {t("media.ads_txt_clear")}
          </button>
          <span className="text-muted fs-12">
            {t("media.ads_txt_clear_hint")}
          </span>
        </div>
      ) : null}
      <div className="hstack gap-2 mt-5 justify-content-center">
        {mode === "view" ? (
          <button
            type="button"
            onClick={() => {
              onClose();
            }}
            className="btn btn-primary mx-auto fs-14 w-25"
          >
            {t("media.Check")}
          </button>
        ) : (
          <>
            <button
              className="btn btn-soft-secondary fs-14 w-25"
              type="button"
              color="light"
              onClick={() => onClose()}
            >
              {t("media.Cancel")}
            </button>
            <button type="submit" className="btn btn-primary fs-14 w-25">
              {t("media.Save")}
            </button>
          </>
        )}
      </div>
    </form>
  );
};

export default AdsTxt;
